import { Observable } from 'rxjs';

import { HttpEvent, HttpHandler, HttpRequest, HttpInterceptor } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { httpParamsToObject } from '../helpers/http-params-to-object';
import { httpParamsTransformer } from '../helpers/http-params-transformer';
import { SN_API_URL } from '../providers/api-url.provider';

@Injectable()
export class SnApiParamsInterceptor implements HttpInterceptor {
  constructor(@Inject(SN_API_URL) private readonly _apiUrl: string) {}

  public intercept(request: HttpRequest<any>, handler: HttpHandler): Observable<HttpEvent<any>> {
    if (!request.url.startsWith(this._apiUrl)) {
      return handler.handle(request);
    }

    return handler.handle(this._paramsTransformer(request));
  }

  private _paramsTransformer(request: HttpRequest<any>): HttpRequest<any> {
    const requestParamsObject = httpParamsToObject(request.params);

    return request.clone({
      params: httpParamsTransformer(requestParamsObject),
    });
  }
}
